import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Component } from "@angular/core";
import { VehiclesService } from "../../../../../shared/services/vehicles.service";
import { Utils } from "../../../../../shared/utils/Utils";
import { DataService } from "../../../../../shared/services/municipios.service";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { DepartamentoService } from "../../../../../shared/services/departamentos.service";
const Swal = require("sweetalert2");

export function noEspaciosValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value || "";
  return value.trim().length === 0 ? { noEspacios: true } : null;
}
@Component({
  selector: "app-listado-departamento",
  templateUrl: "./listado-departamento.component.html",
  styleUrls: ["./listado-departamento.component.scss"],
})
export class ListadoDepartamentoComponent {
  public searchText: string = ""; // Texto de búsqueda
  pageSize1: number = 5;
  page1: number = 1;
  totalItems: number;
  disabled = true;
  selectedEstado: any;
  municipiosRutas: any[] = [];
  editMode: boolean;
  municipioSeleccionado: any;
  filteredTableItems: VehiclesService[];
  formMUNICIPIOS: FormGroup;
  departamentos: any;

  constructor(
    private dataService: DataService,
    private departamentosService: DepartamentoService,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.selectedEstado = "";
    this.listarMunicipios();
    this.cargarDepartamentos();

    this.formMUNICIPIOS = this.fb.group({
      IDEP: [null],
      MUNICIPIO: [null, [Validators.required, noEspaciosValidator]],
    });
  }

  avisoInactivarMunicipio(IDMUN: string) {
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar el municipio: ${IDMUN}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.dataService.inactivarMunicipio(IDMUN).subscribe({
          next: (response) => {
            Swal.fire({
              icon: "success",
              title: "INACTIVADO CORRECTAMENTE",
              confirmButtonText: "Aceptar",
            });

            // ✅ Resetear formulario y recargar lista
            this.formMUNICIPIOS.reset();
            this.listarMunicipios(); // O el método que recargue los municipios inactivos
          },

          error: (error) => {
            console.error("Error:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.error?.message || "No se pudo inactivar el municipio",
              confirmButtonText: "Aceptar",
            });
          },
        });
      }
    });
  }

  private cargarDepartamentos(): void {
    this.departamentosService.getTodos().subscribe({
      next: (data) => (this.departamentos = data),
    });
  }

  listarMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (data) => {
        if (Array.isArray(data)) {
          this.municipiosRutas = data;
          this.filteredTableItems = this.municipiosRutas; // ✅ Necesario para que funcione paginación y filtro
        }
      },
      error: (err) => {
        console.error("Error al cargar contratos", err);
      },
    });
  }

openModalMunicipio(content: any, IDMUN?: string): void {
  if (IDMUN) {
    this.editMode = true;

    this.dataService.getMunicipioPorIDMUN(IDMUN).subscribe({
      next: (municipio) => {
        this.municipioSeleccionado = municipio;
        this.formMUNICIPIOS.patchValue(municipio);
        this.modalService.open(content, { size: "lg", backdrop: "static" });
      },
      error: (err) => {
        this.mostrarError(err, "Error al cargar el municipio por IDMUN");
      }
    });

  } else {
    this.editMode = false;
    this.municipioSeleccionado = null;
    this.formMUNICIPIOS.reset({ estado: true });
    this.modalService.open(content, { size: "lg", backdrop: "static" });
  }
}


  guardarMunicipio(): void {
    if (this.formMUNICIPIOS.invalid) {
      const departamento = this.formMUNICIPIOS.get("IDEP");
      const municipio = this.formMUNICIPIOS.get("MUNICIPIO");

      let mensaje = "Por favor, complete todos los campos obligatorios.";

      if (departamento?.errors?.noEspacios || municipio?.errors?.noEspacios) {
        mensaje = "No se permiten campos vacíos ni solo espacios.";
      }

      Swal.fire({
        icon: "warning",
        title: "Campos inválidos",
        text: mensaje,
      });
      return;
    }

    const datosMunicipio = {
      ...this.formMUNICIPIOS.value,
      usuario: "admin",
    };

    if (this.editMode && this.municipioSeleccionado?.IDMUN) {
      const id = this.municipioSeleccionado.IDMUN;

      const datosAnteriores = {
        ...this.municipioSeleccionado,
        usuario: "admin",
      };

      const sinCambios =
        JSON.stringify(datosAnteriores) === JSON.stringify(datosMunicipio);
      if (sinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones.",
        });
        return;
      }

      this.dataService.editarMunicipio(id, datosMunicipio).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Municipio actualizado",
            text: "Los datos del municipio se actualizaron correctamente.",
          });
          this.cerrarModalYRecargar();
        },
        error: (err) =>
          this.mostrarError(err, "Error al actualizar el municipio"),
      });
    } else {
      this.dataService.crearMunicipio(datosMunicipio).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Municipio creado",
            text: "El municipio se ha registrado correctamente.",
          });
          this.formMUNICIPIOS.reset({ estado: true });
          this.cerrarModalYRecargar();
        },
        error: (err) => this.mostrarError(err, "Error al crear el municipio"),
      });
    }
  }

  cerrarModalYRecargar() {
    this.modalService.dismissAll();
    this.formMUNICIPIOS.reset();
    this.listarMunicipios(); // O el método que recargue los municipios
  }

  mostrarError(error: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: error.error?.message || "Ocurrió un error inesperado",
    });
  }

  filterData() {
    const search = this.searchText.toLowerCase();
    this.filteredTableItems = this.municipiosRutas
      .filter((item) => {
        const municipio = item.MUNICIPIO?.toLowerCase() || "";
        const departamento = item.DEPARTAMENTO?.toLowerCase() || "";
        return municipio.includes(search) || departamento.includes(search);
      })
      .sort((a, b) => {
        // Ordenar primero por departamento, luego por municipio
        const depA = (a.DEPARTAMENTO || "").toLowerCase();
        const depB = (b.DEPARTAMENTO || "").toLowerCase();
        if (depA < depB) return -1;
        if (depA > depB) return 1;
        const munA = (a.MUNICIPIO || "").toLowerCase();
        const munB = (b.MUNICIPIO || "").toLowerCase();
        if (munA < munB) return -1;
        if (munA > munB) return 1;
        return 0;
      });
    this.page1 = 1; // Reiniciar a la primera página al buscar
  }

  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
}